import Image12 from "../../Assets/Rough Emerald/63c203024d11788d66ec755011fcc71a.jpg?format=webp"
import Image13 from "../../Assets/Rough Emerald/292f2e634e76e2b94b0cee89de523ed2.jpg?format=webp"
import Image14 from "../../Assets/Rough Emerald/528976bfbf695cadce08a55703a2d298.jpg?format=webp"
import Image15 from "../../Assets/Rough Emerald/112447571ba1e22c7d8274652f18a395.jpg?format=webp"
import Image16 from "../../Assets/Rough Emerald/a1a044962d935cfc33b3798e2462bb7c.jpg?format=webp"
import Image17 from "../../Assets/Rough Emerald/c5e5f0dce76124239f0854d037c369d5.jpg?format=webp"
import Image18 from "../../Assets/Photos-new/image_2025-05-25_12-07-29.png?format=webp"
import Image19 from "../../Assets/Photos-new/image_2025-05-25_12-07-50.png?format=webp"

/*new images*/

import imgr1of11 from "../../Assets/the-rough-emerold-imgs/imgr1of11.jpg?format=webp"
import imgr2of11 from "../../Assets/the-rough-emerold-imgs/imgr2of11.jpg?format=webp"
import imgr3of11 from "../../Assets/the-rough-emerold-imgs/imgr3of11.jpg?format=webp"
import imgr4of11 from "../../Assets/the-rough-emerold-imgs/imgr4of11.jpg?format=webp"
import imgr5of11 from "../../Assets/the-rough-emerold-imgs/imgr5of11.jpg?format=webp"
import imgr6of11 from "../../Assets/the-rough-emerold-imgs/imgr6of11.jpg?format=webp"
import imgr7of11 from "../../Assets/the-rough-emerold-imgs/imgr7of11.jpg?format=webp"
import imgr8of11 from "../../Assets/the-rough-emerold-imgs/imgr8of11.jpg?format=webp"
import imgr9of11 from "../../Assets/the-rough-emerold-imgs/imgr9of11.jpg?format=webp"
import imgr10of11 from "../../Assets/the-rough-emerold-imgs/imgr10of11.jpg?format=webp"
import imgr11of11 from "../../Assets/the-rough-emerold-imgs/imgr11of11.jpg?format=webp"

export const roughEmeralds = [
    {
      id: "r1",
      image: imgr1of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r2",
      image: imgr2of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r3",
      image: imgr3of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r4",
      image: imgr4of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r5",
      image: imgr5of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r6",
      image: imgr6of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r7",
      image: imgr7of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r8",
      image: imgr8of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r9",
      image: imgr9of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r10",
      image: imgr10of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r11",
      image: imgr11of11,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r12",
      image: Image12,
      weight: 125.7,
      origin: "Colombia",
      color: "Deep Green",
      formation: "Hydrothermal",
      price: "$12,500",
      dimensions: "4.2 × 3.1 × 2.8 cm",
    },
    {
      id: "r13",
      image: Image13,
      weight: 98.3,
      origin: "Zambia",
      color: "Vivid Green",
      formation: "Schist",
      price: "$9,800",
      dimensions: "3.8 × 2.9 × 2.5 cm",
    },
    {
      id: "r14",
      image: Image14,
      weight: 156.2,
      origin: "Brazil",
      color: "Medium Green",
      formation: "Pegmatite",
      price: "$15,600",
      dimensions: "5.1 × 3.7 × 3.2 cm",
    },
    {
      id: "r15",
      image: Image15,
      weight: 87.5,
      origin: "Ethiopia",
      color: "Bluish Green",
      formation: "Hydrothermal",
      price: "$8,750",
      dimensions: "3.5 × 2.8 × 2.3 cm",
    },
    {
      id: "r16",
      image: Image16,
      weight: 112.8,
      origin: "Afghanistan",
      color: "Rich Green",
      formation: "Hydrothermal",
      price: "$11,280",
      dimensions: "4.0 × 3.2 × 2.7 cm",
    },
    {
      id: "r17",
      image: Image17,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
    {
      id: "r18",
      image: Image18,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
    {
      id: "r19",
      image: Image19,
      weight: 143.5,
      origin: "Colombia",
      color: "Deep Bluish Green",
      formation: "Hydrothermal",
      price: "$14,350",
      dimensions: "4.5 × 3.4 × 3.0 cm",
    },
  ]
  